<div class="container">

  <app-header-dialog [iconName]="'noise_control_off'">
    TAVI - Profissional Credenciado
  </app-header-dialog>


  <div *ngIf="entityForm">

    <div class="content">

      <mat-form-field appearance="outline">
        <mat-label>Categoria</mat-label>
        <mat-select [errorStateMatcher]="matcher" [formControl]="entityForm.controls.category">
          <mat-option *ngFor="let type of types" [value]="type.id">
            {{ type.name }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="entityForm.controls.category.hasError('required')">
          Selecione uma categoria
        </mat-error>
      </mat-form-field>


      <mat-form-field appearance="outline">
        <mat-label>Nome</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.name"
          autocomplete="off">
      </mat-form-field>

      <mat-form-field style='width: 80px;' appearance="outline">
        <mat-label>Estado</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.state"
          autocomplete="off">
      </mat-form-field>

    </div>

    <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
      <button *ngIf="!isEdit" matTooltip='Inserir' mat-raised-button
        (click)="matDialogRef.close(['insert', entityForm])" [disabled]="entityForm.invalid">
        <mat-icon class='icon-done'>check_circle_outline</mat-icon>
      </button>
      <button *ngIf="isEdit" matTooltip='Alterar' mat-raised-button (click)="matDialogRef.close(['update', entityForm])"
        [disabled]="entityForm.invalid">
        <mat-icon class='icon-done'>check_circle_outline</mat-icon>
      </button>

    </div>

  </div>

</div>